import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { SectionHeading, CTABand } from "../components/blocks";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQ as FAQ_DATA } from "../lib/data";

export default function FAQ() {
  return (
    <div>
      <Seo
        title="FAQ — Questions fréquentes | Carnier Toiture et Habitat (Oise)"
        description="Vos questions sur nos prestations de toiture, façade et habitat dans l'Oise : devis gratuit, délais, zones d'intervention, démoussage et traitement de toiture."
      />

      <section className="bg-vegetal-800 text-white">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.22em] font-semibold text-terracotta-300">FAQ</span>
            <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-balance">Vos questions, nos réponses</h1>
          </Reveal>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 md:px-10 py-16 md:py-24">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQ_DATA.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="rounded-xl bg-white border border-neutral-200 px-5 shadow-sm">
                <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-heading font-semibold text-neutral-900 hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-neutral-700 leading-relaxed">{item.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>

      <CTABand />
    </div>
  );
}
